import TableWrapperController from '../lib/controllers/table-wrapper-controller.js'

export default function(application) {
  application.register('table-wrapper', TableWrapperController)
}